/**
 * Assigns each label the first letter of its own text not already claimed by an earlier label in the
 * list, so a menu's items never fight over the same key. A label with no letter left unclaimed gets
 * none, which just means it has no direct keyboard shortcut while the menu is open.
 */
export function assignMenuShortcutKeys(labels: readonly string[]): (string | undefined)[] {
	const claimed = new Set<string>()
	return labels.map(label => {
		for (const char of label.toLowerCase()) {
			if (/[a-z]/.test(char) && !claimed.has(char)) {
				claimed.add(char)
				return char
			}
		}
		return undefined
	})
}
